import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/authContext';
import { Layout } from '../components/layout';

interface ProtectedRouteProps {
  children: JSX.Element;
  withLayout?: boolean; // Default true, set to false for pages that don't need sidebar (e.g., OrderPage, DragPage)
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, withLayout = true }) => {
  const authContext = useContext(AuthContext);

  if (!authContext || authContext.isLoading) {
    return <div>Loading...</div>;
  }
  if (!authContext.isLoggedIn || !authContext.userEmail) {
    return <Navigate to="/login" replace />;
  }

  // Wrap with Layout by default, unless explicitly disabled
  if (withLayout) {
    return <Layout>{children}</Layout>;
  }

  return children;
};

export default ProtectedRoute;
